import type React from 'react';
import type { ICandidateStore } from '../../../stores/JobApplicationStore/CandidateStore';
import { observer } from 'mobx-react';
import { Accordion, AccordionItem } from 'braid-design-system';
import Details from './Details';
import useBucketLabel from 'src/utils/hooks/useBucketLabel';
import type { EmployerLocale } from 'src/siteConfig';
import { convertToIsVerifiedId } from 'src/utils/eventMappers';

interface Props {
  candidateStore: ICandidateStore;
  locale: EmployerLocale;
}

const PreviousApplicationsMobile: React.FC<Props> = ({
  candidateStore,
  locale,
}) => {
  const {
    selectedPreviousApplication,
    previousApplications,
    selectPreviousApplication,
    unselectPreviousApplication,
    jobApplication,
  } = candidateStore;

  const { getLabelFromBucket } = useBucketLabel();
  return (
    <Accordion>
      {previousApplications.map((previousApplication) => (
        <AccordionItem
          expanded={previousApplication === selectedPreviousApplication}
          onToggle={() =>
            previousApplication === selectedPreviousApplication
              ? unselectPreviousApplication()
              : selectPreviousApplication(previousApplication.id)
          }
          id={previousApplication.id}
          key={previousApplication.id}
          label={`${
            previousApplication.positionSummary.title
          } (${getLabelFromBucket(previousApplication.bucket)})`}
        >
          <Details
            previousApplication={previousApplication}
            locale={locale}
            isVerifiedId={convertToIsVerifiedId(jobApplication.profile)}
          />
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default observer(PreviousApplicationsMobile);
